import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=00234f72&scoped=true&"
import script from "./Campaign.vue?vue&type=script&lang=js&"
export * from "./Campaign.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/manager-select-modal.scss?vue&type=style&index=0&id=00234f72&scoped=true&lang=scss&"
import style1 from "@/sass/07_elements/multiselect.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00234f72",
  null
  
)

export default component.exports